export default __webpack_public_path__ + "static/media/b2bPhone.eece394e.png";